import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Memory = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2 2.348h12a1.669 1.669 0 0 1 1.667 1.666v6.333a.333.333 0 0 1-.333.334H.667a.333.333 0 0 1-.333-.334V4.014a1.669 1.669 0 0 1 1.667-1.666Zm13 7.666v-6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6h14ZM14.001 13.68h-12a.333.333 0 0 1-.333-.334v-1.333a.333.333 0 1 1 .667 0v1h11.333v-1a.333.333 0 1 1 .666 0v1.333a.333.333 0 0 1-.333.334Z" />
      <path d="M8.001 13.68a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1A.333.333 0 0 1 8 13.68ZM6.001 13.68a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1A.333.333 0 0 1 6 13.68ZM4.001 13.68a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1A.333.333 0 0 1 4 13.68ZM10.001 13.68a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1a.333.333 0 0 1-.334.333ZM12.001 13.68a.333.333 0 0 1-.333-.333v-1a.333.333 0 1 1 .667 0v1a.333.333 0 0 1-.334.333ZM7.001 4.348h2a.333.333 0 0 1 .334.333v3.666A.333.333 0 0 1 9 8.681h-2a.333.333 0 0 1-.333-.334V4.681a.333.333 0 0 1 .333-.333Zm1.667.666H7.335v3h1.333v-3ZM3.001 4.348h2a.333.333 0 0 1 .334.333v3.666A.333.333 0 0 1 5 8.681h-2a.333.333 0 0 1-.333-.334V4.681a.333.333 0 0 1 .333-.333Zm1.667.666H3.335v3h1.333v-3ZM11.001 4.348h2a.333.333 0 0 1 .334.333v3.666a.333.333 0 0 1-.334.334h-2a.333.333 0 0 1-.333-.334V4.681a.333.333 0 0 1 .333-.333Zm1.667.666h-1.333v3h1.333v-3Z" />
    </svg>
  );
};

Memory.category = 'product-category';

Memory.displayName = 'Memory';
